/*
 * Componentes em chunk próprio (import() sob demanda): o código só desce
 * quando o componente aparece pela primeira vez, em vez de pesar no forum.js
 * da primeira carga. O chunk é pedido uma vez só; as próximas instâncias
 * desenham na hora.
 */
import Component from 'flarum/common/Component';
/**
 * Um componente que desenha `placeholder` até o chunk chegar e, daí em
 * diante, o componente de verdade com os mesmos atributos e filhos.
 * Se o download falhar, tenta de novo na próxima vez que aparecer.
 */
export function lazyComponent(load, placeholder = () => null) {
  let loaded = null;
  let pending = null;
  const fetch = () => {
    pending ||= load().then(component => {
      loaded = component;
      m.redraw();
    }, () => {
      pending = null;
    });
  };
  return class LazyComponent extends Component {
    oninit(vnode) {
      super.oninit(vnode);
      if (!loaded) fetch();
    }
    view(vnode) {
      const Comp = loaded;
      return Comp ? m(Comp, vnode.attrs, vnode.children) : placeholder();
    }
  };
}
flarum.reg.add('ramon-canela', 'forum/utils/lazy', { lazyComponent: lazyComponent, });